let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("4Viii"), load("aS6Ln")]).then(() => parcelRequire('bVqSD'));